export { default } from './VariationInfo';
